// stores/auth.js
import { create } from "zustand";
import { fbAuth } from "../../services/firebaseService/connection";

const useAuthStore = create((set) => ({
  isSuperadmin: false,
  isAuthenticated: false,
  user: null,

  setSuperadmin: (isSuperadmin) => set({ isSuperadmin, isAuthenticated: true }),

  setUser: (user) => set({ user }),

  logout: () =>
    set({ isSuperadmin: false, isAuthenticated: false, user: null }),

  checkSuperadmin: async () => {
    if (fbAuth.currentUser) {
      await fbAuth.currentUser.getIdToken(true);
      const token = await fbAuth.currentUser.getIdTokenResult();
      set({
        isSuperadmin: token.claims.superadmin === true,
        isAuthenticated: true,
        user: fbAuth.currentUser,
      });
    }
  },

  reset: () => set({ isSuperadmin: false, isAuthenticated: false, user: null }),
}));

export default useAuthStore;
